import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-collaborative-initiatives',
  templateUrl: './collaborative-initiatives.component.html',
  styleUrls: ['./collaborative-initiatives.component.scss']
})
export class CollaborativeInitiativesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
